<template>
  <div class="Panel">
    <div class="tip"><span>{{tip}}</span></div>
    <el-card shadow="never" class="P-Login">
      <div class="G-Title"><i class="el-icon-user-solid"></i><span>找回密码</span></div>
      <el-drawer
        :visible.sync="drawer"
        direction='btt'
        :lock-scroll="false"
        :before-close="handleClose">
        <span>{{new_pass}}</span>
      </el-drawer>
      <div>
        <el-form @keypress.enter.native="submitForm('ruleForm')" :model="ruleForm" status-icon :rules="rules" ref="ruleForm" class="AuthForm">
          <el-form-item prop="username" class="form-group">
            <el-input type="username" v-model.trim="ruleForm.username" autocomplete="off" placeholder="请输入用户名" ></el-input>
          </el-form-item>
          <el-form-item prop="email" class="form-group">
            <el-input type="text" v-model.trim="ruleForm.email" autocomplete="off" placeholder="请输入邮箱"></el-input>
          </el-form-item>
          <el-form-item class="form-group">
            <el-button type="primary" @click="submitForm('ruleForm')" :loading="loading" style="width: 100%">找回密码
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import {request} from '../../network/request'
export default {
  name: 'forget',
  mounted () {
    request({
      url: '/api/tip',
      method: 'post'
    }).then(res => {
      this.tip = res.data.tip
    }).catch(err => {
      this.$message.error('网络出错')
      this.tip = err
    })
  },
  methods: {
    checkSpecialKey (str) {
      var specialKey = "[`~!#@$^&*()=|{}':;'\\[\\].<>/?~！#￥……&*（）——|{}【】‘；：”“'。，、？]‘'"
      for (var i = 0; i < str.length; i++) {
        if (specialKey.indexOf(str.substr(i, 1)) !== -1) {
          return false
        }
      }
      return true
    },
    handleClose (done) {
      this.$confirm('请尽快登录到后台修改密码!', {
        lockScroll: false
      })
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true
          let data = new URLSearchParams()
          data.append('username', this.ruleForm.username)
          data.append('email', this.ruleForm.email)
          request({
            url: '/api/forget',
            method: 'post',
            data: data
          }).then(res => {
            if (res.data.status === 1) {
              this.$message.error('用户名与邮箱不匹配')
              this.loading = false
            }
            if (res.data.status === 0) {
              this.new_pass = '已为您重置密码为：【' + res.data.new_pass + '】'
              this.drawer = true
              this.loading = false
            }
          }).catch(err => {
            console.log(err)
            this.loading = false
          })
        }
      })
    }
  },
  data () {
    var validateEmail = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请正确填写邮箱'))
      } else {
        if (value !== '') {
          var reg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
          if (!reg.test(value)) {
            callback(new Error('请输入有效的邮箱'))
          }
        }
        callback()
      }
    }
    let validateName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入账号'))
      } else if (value.length < 2 || value.length > 20 || !this.checkSpecialKey(value)) {
        callback(new Error('名称 必须介于 2 - 20 个字符之间。'))
      } else {
        callback()
      }
    }
    return {
      tip: '...',
      loading: false,
      PageLoading: true,
      drawer: false,
      new_pass: '',
      ruleForm: {
        email: '',
        username: ''
      },
      rules: {
        email: [
          {validator: validateEmail, trigger: 'blur'}
        ],
        username: [
          {validator: validateName, trigger: 'blur'}
        ]
      }
    }
  }
}
</script>

<style scoped>
  .P-Login {
    max-width: 500px;
    margin-right: auto !important;
    margin-left: auto !important;
  }

  .AuthForm {
    max-width: 320px;
    margin: 0 auto;
  }

  .form-group {
    margin-bottom: 3rem !important;
    margin-top: 3rem !important;
  }

  .G-Title {
    border-bottom: 1px solid #f2f2f2 !important;
    text-align: left;
  }

  .tip {
    font-size: 18px;
    text-align: center !important;
    margin-bottom: 24px !important;
    margin-top: 14px !important;
    color: #999 !important;
    height: 27px;
  }

  .my-3 {
    margin-bottom: 1rem !important;
    margin-top: 1rem !important;
    font-size: 14px;
  }
  .Panel{
    padding-bottom: 3rem!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/user/forget.vue